<template>
  <div class="flex-container">
    <el-breadcrumb class="flex-item" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="text-center" :to="{ path: '/sys/linXuanChannel/list' }">
        <span>{{ title }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-form
      class="flex-item role-form"
      ref="validateForm"
      :model="form"
      size="mini"
      :rules="rules"
      :validate-on-rule-change="false"
      label-width="200px"
    >
      <el-row>
        <el-col :span="24" v-if="(operator==='0' || operator==='1')&& workFlowList.length>1">
          <el-form-item label="选择文件上传批次：">
            <el-select v-model="flowId" placeholder="请选择批次" @change="selectWorkFlow">
              <el-option
                  v-for="item in workFlowList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div>
          <el-col :span="24">
            <el-form-item label="支付业务许可证上传：">
              <div v-if="isModify">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :show-file-list="true"
                    :file-list="fileList"
                    accept=".pdf"
                    :limit= "1"
                    :on-remove="handleRemove">
                  <span>
                    <el-button size="mini" type="primary" v-if="fileId===''">上传文件</el-button>
                    <el-button size="mini" type="primary" @click="change()" v-else>重新上传</el-button>
                  </span>
                </el-upload>
              </div>
              <div v-else>
                <div slot="content" v-for="(file, index) in fileList" :key="index">
                  <el-button @click.native.prevent="bigFileDown(file)" type="text" size="small" >{{file.name }} （上传时间：{{file.createTime}}）</el-button>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
    </el-form>
    <div class="flex-item" style="text-align: center">
        <div v-if="isModify">
          <el-button size="mini" @click="back">返回</el-button>
          <!-- <el-button size="mini" type="primary" @click="save(0)">保存</el-button> -->
          <el-button size="mini" type="primary" @click="save(1)">提交</el-button>
        </div>
        <div v-else><el-button size="mini" @click="back">返回</el-button></div>
    </div>
  </div>
  </template>

  <script>
  import {saveWorkflowInfo, deleteFileById, template, fileDownLoad, getWorkflowById,getWorkflowByWfType
  } from "@/api/system/linXuanChannel/linXuanChannel";
  import {SYS_APi_SCREENING_URL} from '@/utils/globals'
  import axios from 'axios';
  import * as util from "@/assets/js/util";
  export default {
    name: "index",
    data() {
      return {
        userRole:'',
        fileId: '',
        channelId: '',
        wfType:'2',
        wfTypeName:"修改",
        title:'支付业务许可证修改',
        uploadUrl: '/file/uploadChunk',
        chunkSize: 9 * 1024 * 1024, // 每个块的大小，5MB
        fileList: [],
        fileListHis:[],
        uploadLoading: null,
        isModify:true,
        isReadOnly:false,
        isAdd:false,
        operator:'',
        flowState:'',
        workFlowList:[],
        //operatorTypeList:[],
        isShow:true,
        //operatorType:'',
        flowId:'',
        parentId:'',
        form: {},
        workflow:null,
        uploadType:'',
        rules: {},
      };
    },
    mounted() {
      this.initPage();
    },
    methods: {
      initPage(){
        this.userRole=util.session("userRole").userRole;
        this.wfType=this.$route.params.wfType;
        this.operator=this.$route.params.operator;
        this.channelId=this.$route.params.channelId;
        this.flowState=this.$route.params.flowState;
        this.isAdd=this.$route.params.isAdd;
        if(this.operator=="0"){
          this.isModify=false;
          this.isReadOnly=true;
        }else{
          this.isModify=true;
          this.isReadOnly=false;
        }
        if(this.isAdd!='add'){
          this.initData();
        }
      },
      initData() {
        this.tableLoading = true;
        getWorkflowByWfType({
          wfType: this.wfType,
          channelId: this.channelId,
          operator: this.operator,
          flowState: this.flowState,
        }).then((res) => {
          this.tableLoading=false;
          if (res.code==200) {
            if(res.data != null && res.data.length>0) {
              this.workFlowList=res.data;
              this.flowId=res.data[0].id;
              this.getWorkflowInfo();
            }
          } else {
            this.$message.error(res.message);
          }
        });
      },
      getWorkflowInfo() {
        this.tableLoading = true;
        getWorkflowById({
          flowId: this.flowId,
        }).then((res) => {
          this.tableLoading=false;
          if (res.code==200) {
            if(res.data != null){
              this.fileList=res.data.fileList;
              this.fileListHis=res.data.fileListHis;
              if(res.data.workflow != null){
                this.fileId=res.data.workflow.fileId;
                this.parentId=res.data.workflow.parentId;
                this.workflow=res.data.workflow;
                this.form = res.data.workflow;
                /*this.operatorType=res.data.workflow.operatorType;
                if(this.operatorType=="1"){
                  this.isShow=false;
                }*/
              }
              if(res.data.file != null) {
                //this.form = res.data.file;
              }
            }
          } else {
            this.$message.error(res.message);
          }
        });
      },
      selectWorkFlow(value){
        this.flowId=value;
        this.getWorkflowInfo();
      },
      
      save(state) {
        if(this.fileList.length==0 && state=="1"){
          this.$message.warning("请上传文件！");
          return;
        }
        if(state=="1" && (this.fileId==null || this.fileId=="")){
          this.$message.warning("请上传文件！");
          return;
        }
        let stateStr='';
        if(state=="1"){
          stateStr='提交';
        }else{
          stateStr='保存';
        }
        const loading = this.$loading({
              lock: true,
              text: stateStr+'中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        saveWorkflowInfo({
          fileId:this.fileId,
          channelInfo:{"id":this.channelId},
          flag:"1"
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
            type: "success",
            message: stateStr+"成功!",
            });
            loading.close();
          } 
          this.back();
        }) 
      },
      change(){
        this.fileList=[];
      },
      back() {
        this.$router.go(-1);
      },
      downloadTemplate() {
        const loading = this.$loading({
          lock: true,
          text: "正在下载...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        let fileName="商户及门店模板.zip";
        let type = "1";
        if(this.uploadType==='merchant_quit'){
          type = "2";
          fileName="商户门店退出模板.zip";
        }
        if(this.uploadType==='merchant_update'){
          type = "4";
          fileName="商户门店修改模板.zip";
        }
        template({
          type:type
        }).then((res) => {
          loading.close();
          let blob = new Blob([res]);
          let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url); // 释放该 url
          this.$message.success("下载成功");
        }).catch(error => {
          loading.close();
          this.$message.error("下载失败");
        });
      },
      fileDown(fileName) {
        const loading = this.$loading({
          lock: true,
          text: "正在下载...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        fileDownLoad({
          url:fileName.url,
          name:fileName.name
        }).then((res) => {
          loading.close();
          let blob = new Blob([res]);
          let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.rel = "noopener noreferrer";
          a.download = fileName.name;
          a.click();
          window.URL.revokeObjectURL(url); // 释放该 url
          this.$message.success("下载成功");
        }).catch(error => {
          loading.close();
          this.$message.error("下载失败");
        });
      },
      bigFileDown(fileName) {
        // 获取 Token
        const token = this.$store.state.token; // 确保这里能取到 token
        if (!token) {
          this.$message.error("未登录，无法下载");
          return;
        }

        // 显示 Loading
        const loading = this.$loading({
          lock: true,
          text: "正在准备下载...",
          background: "rgba(0, 0, 0, 0.7)"
        });
        // 构造请求 URL (注意：不再拼 token 参数了)
        let apiUrl = SYS_APi_SCREENING_URL + "/filedown/bigFileDownLoad";
        const params = new URLSearchParams();
        params.append('url', fileName.url);
        params.append('name', fileName.name);
        const finalUrl = `${apiUrl}?${params.toString()}`;

        // 核心下载逻辑
        this.startStreamDownload(finalUrl, token, fileName.name)
            .then(() => {
              this.$message.success("下载成功");
            })
            .catch(err => {
              console.error(err);
              this.$message.error("下载失败或取消");
            })
            .finally(() => {
              loading.close();
            });
      },
      // 使用 Fetch API 进行流式下载
      async startStreamDownload(url, token, filename) {
        try {
          // 1. 弹出浏览器原生的“保存文件”对话框 (用户选择保存位置)
          // 这是关键：只有这样才能在 JS 中拿到一个可写入的流句柄
          const fileHandle = await window.showSaveFilePicker({
            suggestedName: filename,
            types: [{
              description: 'pdf File',
              accept: { 'application/pdf': ['.pdf'] },
            }],
          });

          // 2. 创建可写流
          const writableStream = await fileHandle.createWritable();

          // 3. 发起 Fetch 请求 (这里可以带上 Headers)
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'token': token, // 【关键】Token 放在 Headers 中
              // 如果还有其他必须的 Header，也在这里添加
            }
          });

          if (!response.ok) {
            throw new Error(`服务器错误: ${response.status}`);
          }

          // 4. 获取响应体的 Reader (读取流)
          const reader = response.body.getReader();

          // 5. 循环读取并写入硬盘
          while (true) {
            const { done, value } = await reader.read();
            if (done) {
              break;
            }
            // 将读取到的数据块写入文件流
            await writableStream.write(value);
          }

          // 6. 关闭流
          await writableStream.close();

        } catch (err) {
          // 如果用户点击了“取消”保存，err.name 会是 'AbortError'，可以忽略
          if (err.name !== 'AbortError') {
            throw err; // 重新抛出其他错误
          }
        }
      },

      // 在文件上传之前拆分成多个块
      beforeUpload(file) {
        const allowedType = "pdf";
        const fileSuffix = file.name.split(".").pop().toLowerCase();
        if (fileSuffix !== allowedType) {
          this.$message.error(`只允许上传.pdf格式的压缩包文件！`);
          return false;
        }
        this.uploadLoading = this.$loading({
          lock: true,
          text: '文件上传中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.chunkedUpload(file);
        return false; // 取消默认的上传
      },
      // 分块上传
      async chunkedUpload(file) {
        const uploadId = Date.now()
        const totalChunks = Math.ceil(file.size / this.chunkSize);  // 计算总块数
        let start = 0;
        let end = this.chunkSize;
        let chunkIndex = 0;

        // 上传每个块
        while (start < file.size) {
          const chunk = file.slice(start, end);
          const formData = new FormData();
          formData.append('file', chunk);
          formData.append('fileName', file.name);
          // 渠道申报：channel_insert、渠道退出：channel_quit、新增、修改商户/门店：merchant_insert、商户/门店退出：merchant_quit
          formData.append('uploadType', this.uploadType);
          formData.append('uploadId', uploadId);
          formData.append('chunkIndex', chunkIndex); // 当前块的索引
          formData.append('totalChunks', totalChunks); // 总块数

          try {
            const response = await this.uploadChunk(formData); // 上传当前块
            console.log(response);
            if(response.data.code!=='200'){
              this.$message.error(`文件上传失败: ${response.data.message}`);
              this.closeLoading();
              break;
            }
            if (chunkIndex === totalChunks - 1) {
              // 如果是最后一块，上传完成后显示信息
              this.handleSuccess(response, file, this.fileList);
              this.$message.success('文件上传完成');
              this.closeLoading();
            }
            start = end;
            end = Math.min(end + this.chunkSize, file.size);
            chunkIndex++;
          } catch (err) {
            console.error('上传失败:', err);
            this.$message.error('文件上传失败');
            this.closeLoading();
            break;
          }
        }
      },

      closeLoading() {
        if (this.uploadLoading) {
          this.uploadLoading.close();
          this.uploadLoading = null;
        }
      },

      // 上传每个文件块
      uploadChunk(formData) {
        return new Promise((resolve, reject) => {
          axios.post(SYS_APi_SCREENING_URL + this.uploadUrl, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
              .then(response => {
                resolve(response);  // 返回响应给调用者
              }).catch(error => {
            console.error('请求失败:', error);
            reject(error);
          });
        });
      },

      handleSuccess(response, file, fileList) {
        try {
          const fileId = response.data.data;
          this.fileId = fileId;
          console.log('文件ID:', fileId);
          this.fileList.push({
            name: file.name,
            url: `${SYS_APi_SCREENING_URL}/file/download/${fileId}`,
          });
        } catch (err) {
          this.fileId = "";
          this.$message.error("文件上传失败！");
          console.error('处理上传响应失败:', err);
        }
      },

      handleError(error, file, fileList) {
        console.log('上传失败', error);
      },
      handleRemove(file, fileList) {
        if(this.fileId==""){
          const fileId = this.fileId;
          if (fileId) {
            deleteFileById({fileId: fileId}).then((res) => {
              if (res.code == 200) {
                this.fileList = fileList.filter(item => item.name !== file.name);
                this.$message({
                  type: "success",
                  message: "上传删除成功!",
                });
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }else{
          this.fileList=[];
        }
      },
    },
  };
  </script>

  <style scoped>
  .el-card {
  height: 100%;
  }

  .btn_box {
  text-align: right;
  margin-top: 8px;
  height: 40px;
  }

  .flex-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  }

  .flex-item:nth-child(1),
  .flex-item:nth-child(3) {
  flex-grow: 0;
  flex-shrink: 0;
  }

  .flex-item:nth-child(2) {
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: auto;
  }
  .role-form {
  margin: 15px 0;
  }
  </style>